import { z } from 'zod';
import { signInSuccessResponseSchema } from './signInResponse';
import { signOutSuccessResponseSchema } from './signOutResponse';

export const statusResponseSchema = z.union([
  signInSuccessResponseSchema,
  signOutSuccessResponseSchema,
]);
